import { HttpError } from '@refinedev/core';
import { actionableErrorMessage } from './actionable-error-message';

export const GENERIC_UPLOAD_ERROR =
  'Não foi possível realizar o upload do arquivo. Tente novamente.';

/** PROD3-231 — quais status trazem mensagem útil: ver `actionableErrorMessage`. */
export const uploadErrorMessage = (error?: HttpError): string =>
  actionableErrorMessage(error, GENERIC_UPLOAD_ERROR);
